import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Linkedin, Facebook, Instagram } from 'lucide-react';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Servizi', path: '/servizi' },
  { name: 'Lavora con noi', path: '/lavora-con-noi' },
  { name: 'Chi siamo', path: '/chi-siamo' },
  { name: 'Contatti', path: '/contatti' },
];

const socialLinks = [
  { name: 'LinkedIn', icon: Linkedin, url: 'https://sm.linkedin.com/company/sellandrec' },
  { name: 'Facebook', icon: Facebook, url: 'https://www.facebook.com/profile.php?id=61579378733599' },
  { name: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/sellandrec/' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav data-testid="navbar" className="sticky top-0 z-50 bg-white/90 backdrop-blur-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" data-testid="navbar-logo" className="flex items-center">
            <span className="text-2xl font-extrabold text-[#1A1A2E]">
              SELL<span className="text-[#E94560]">&</span>REC
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path.replace('/', '') || 'home'}`}
                className={`nav-link text-sm uppercase tracking-wider whitespace-nowrap ${
                  location.pathname === link.path ? 'text-[#E94560]' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            
            {/* Social Icons */}
            <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-200">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`nav-social-${social.name.toLowerCase()}`}
                  className="w-9 h-9 flex items-center justify-center bg-[#1A1A2E] text-white rounded-full hover:bg-[#E94560] transition-colors"
                  title={social.name}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
            
            <Link
              to="/contatti"
              data-testid="nav-cta-button"
              className="btn-primary text-sm"
            >
              Contattaci
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div data-testid="mobile-menu" className="md:hidden pb-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-3 text-lg font-semibold ${
                  location.pathname === link.path ? 'text-[#E94560]' : 'text-[#1A1A2E]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            
            {/* Mobile Social Icons */}
            <div className="flex items-center gap-4 py-4 border-t border-gray-200 mt-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-[#1A1A2E] text-white rounded-full hover:bg-[#E94560] transition-colors"
                >
                  <social.icon size={20} />
                </a>
              ))}
            </div>
            
            <Link
              to="/contatti"
              onClick={() => setIsOpen(false)}
              className="btn-primary inline-block mt-4 text-center w-full"
            >
              Contattaci
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
